<app-table
  modelName="Edições"
  [cols]="columns"
  [service]="subscriberService"
  pageFunctionName="findEditionsCustomizationsTable"
  sortField="editionDate"
  [sortOrder]="1"
  [fixedFilters]="fixedFilters"
  linkTarget="_action"
  [actionFields]="['editionTheme']"
  [addButtonAction]="true"
  (linkAction)="openEdition($event.value)"
  (addButtonClick)="newEdition()"
/>
